type ConfirmCallback = (ok: boolean) => void;

let pendingCallback: ConfirmCallback | null = null;
export const ROUTER_CONFIRM_EVENT = 'router-confirm-request';

export function requestConfirm(callback: ConfirmCallback): void {
  pendingCallback = callback;
  window.dispatchEvent(new Event(ROUTER_CONFIRM_EVENT));
}

export function resolveConfirm(ok: boolean): void {
  if (pendingCallback) {
    pendingCallback(ok);
    pendingCallback = null;
  }
}
